module.exports = __webpack_public_path__ + "static/media/pay-paypal-on.404be45c.png";